// Credits
import { SFX } from '../core/audio';
import { CREDITS } from '../credits';
import { $ } from './dom';
import { WORLDS } from './state';
import { WORLDS as WORLD_DEFS } from '../worlds';
import { setI } from './icons';
import { t } from '../core/i18n';

// ---------- Credits roll (src/credits.ts + the worlds' meta.credits) ----------
export function openCredits() {
  const esc = (t: unknown) => String(t).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' } as Record<string, string>)[c]);
  // The map's music first, then each world's track (meta.credits) in unlock order
  const music = [{ ic: '🗺️', n: t('credits.map'), m: CREDITS.menu }, ...WORLDS.map((w, i) => ({ ic: w.ic, n: w.n, m: WORLD_DEFS[i].meta!.credits })).filter(r => r.m)];
  const rows = music.map(({ ic, n, m }) =>
    `<div class="crrow"><span class="crw">${ic} ${esc(n)}</span><b>${esc(m!.title)}</b><span>${esc(m!.artist)}</span></div>`).join('');
  $('#crRoll').innerHTML = `<div class="crlogo">${esc(t('app.name'))}</div><h3>${esc(t('credits.music'))}</h3>${rows}
    <p class="note">${esc(t('credits.note'))}</p>
    <h3>${esc(t('credits.thanks'))}</h3>${CREDITS.thanks.map(t => `<div>${esc(t)}</div>`).join('')}<div class="crend">🦆</div>`;
  const roll = $('#crRoll'); roll.style.animation = 'none'; void roll.offsetWidth; roll.style.animation = '';
  $('#ovCredits').hidden = false;
}
setI($('#crClose'), 'close');
$('#crClose').addEventListener('click', () => { SFX.play('click'); $('#ovCredits').hidden = true; });
